import React from "react";
import { Box, Stack, Text, VStack, Link, Avatar } from "@chakra-ui/react";
import { FaLinkedin, FaEnvelope } from "react-icons/fa";
import { motion } from "framer-motion";
import avatarSrc from "../assets/me.jpg";

const Footer = () => {
  const linkedInProfileUrl =
    "https://www.linkedin.com/in/harshit-gupta-b87a3b1ba/";
  const email = "harshitgupta3017@gmail.com";

  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
      },
    },
  };

  return (
    <Box
      bgColor="blackAlpha.900"
      color="whiteAlpha.900"
      minH="48"
      px={{ base: "4", md: "16" }}
      py={{ base: "8", md: "6" }}
    >
      <motion.div
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        <Stack direction={["column", "row"]} h="full" alignItems="center">
          <VStack w="full" alignItems={["center", "flex-start"]}>
            <Text fontWeight="semibold" fontSize={{ base: "lg", md: "xl" }}>
              About Us
            </Text>
            <Text
              fontSize={{ base: "sm", md: "md" }}
              letterSpacing="wide"
              textAlign={["center", "left"]}
              mt={{ base: "2", md: "4" }}
            >
              Welcome to Nobto! Your go-to source for crypto guidance and
              insights.
            </Text>
          </VStack>
          <VStack>
            <Avatar
              boxSize={{ base: "12", md: "28" }}
              mt={{ base: "4", md: "0" }}
              src={avatarSrc}
              alt="Founder Avatar"
            />
            <Text fontWeight="semibold" fontSize={{ base: "sm", md: "md" }}>
              Founder
            </Text>
            <Stack direction="row" spacing="3" mt="2">
              <Link
                href={linkedInProfileUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin size={24} />
              </Link>
              <Link href={`mailto:${email}`}>
                <FaEnvelope size={24} />
              </Link>
            </Stack>
          </VStack>
        </Stack>
      </motion.div>
    </Box>
  );
};

export default Footer;
